/**
 * Sync class for import and export of V4 freestyle page
 */
export class FreestylePage {}
